import { ServerErrorCode } from './constants/constants';
import * as authorization from './rest/authorization';
import * as hostConfig from './rest/hostConfig';
import * as router from './rest/router';

export default {
  authorization,
  router,
  hostConfig,
};

export { ServerErrorCode };
